<template>
  <div>
    <PageHeader />
    <ProjInfo :projectInfo="projectInfo" :changelog="changelog" />


    <v-container class="section-block">
        <v-row>
            <v-col class="col-12 col-md-4 col-sm-6">
                <h2>Basic walkthrough</h2>
                <!-- <h4>Basics</h4> -->
                <ol>
                    <li>Open Window > Essential Graphics</li>
                    <li><a href="#install">Import</a> the <code>.mogrt</code> files are into Premiere</li>
                    <li>Drag the <strong>I+I Toolkit</strong> templates into the Premiere timeline</li>
                    <li>Click the clip in the timeline to switch to the <strong>Edit</strong> tab in <strong>Essential Graphics</strong></li>
                    <li>Edit the clip's properties to customize the content of the template</li>
                </ol>
                <h3>Available properties:</h3>
                <ul>
                    <li>Preset</li>
                    <li>Text</li>
                    <li>Footage (organized by footage aspect ratio)</li>
                    <li>Color (background, text, graphics)</li>
                </ul>
            </v-col>
            <v-col class="col-12 col-md-8">
                <v-responsive :aspect-ratio="16/9">
                    <video width="100%" :src="video.tutorial" :poster="images.poster" controls></video>
                </v-responsive>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-12 col-sm-6 col-md-4">
                <div class=" group-header">Features</div>
            </v-col>
            <v-col class="col-12 col-md-8"> </v-col>
        </v-row>
        <v-row>
            <v-col class="col-12 col-sm-6 col-md-4">
                <h2>Responsive text sizing</h2>
                <p>
                    Each text layer within the templates has a set of expressions that limit their size to fit the design. 
                    As text layers get too wide or tall they will scale down to fit the layout.
                </p>
                <p>
                    Simply type in the Essential Graphics panel and add line-breaks as needed.
                </p>
            </v-col>
            <v-col class="col-12 col-md-8">
                <v-responsive :aspect-ratio="16/9">
                    <video width="100%" :src="video.responsive" muted autoplay loop controls></video>
                </v-responsive>
            </v-col>

        </v-row>
        <v-row>
            <v-col class="col-12 col-sm-6 col-md-4">
                <h2>Color palettes</h2>
            </v-col>
            <v-col class="col-12 col-md-8"> </v-col>
            <v-col class="col-12 col-md-8 col-sm-12">
                <img :src="images.palette" width="100%">
            </v-col>
            <v-col class="col-12 col-md-4 col-sm-12">
            </v-col>

            <v-col class="col-12 col-md-4 col-sm-6">
                <img :src="images.picker" width="100%">
            </v-col>
            <v-col class="col-12 col-md-4 col-sm-6">
                <p>
                    Each template includes a set of 5 colors, each with 5 values (plus white and near black). 
                </p>
                <p>
                    Template will contain different sets of color selectors based on their available elements. 
                </p>
                <p>
                    Select a palette color to set the overall theme, then pick the value (brightness) of each element type.
                </p>
                <p>
                    (Optional) Uncheck <strong>Show Background</strong> to disable the background layer and place text and graphics on top of a footage layer.
                </p>
            </v-col>
                <!-- <video width="100%" :src="video.tutorial" :poster="images.poster" controls /> -->
        </v-row>
    </v-container>


    <InstallInfo id="install" name="Windfish" mogrt :hosts="['After Effects']"/>
    
    <v-container class="section-block">
        <v-row>
            <v-col class="col-12 col-sm-6 col-md-4">
                <div class=" group-header">Included templates</div>
            </v-col>
        </v-row>
            
        <div v-for="(type, typeIndex) in morgts" :key="typeIndex" class="state-box">
            <h2 :id="typeIndex">{{ typeIndex | uppercase }}</h2>
            <v-row>
                <v-col v-for="(state, stateIndex) in type" :key="stateIndex" class="col-12 col-sm-6 col-md-4" no-gutters>
                    <video :src="require(`../assets/video/ii-toolkit/${state}.mp4`)" style="width: inherit" :alt="state" muted autoplay loop/>
                    <h4>{{ state | removeUnderscores }}</h4>
                </v-col>
            </v-row>
        </div>
        <div v-for="(type, typeIndex) in morgtsImg" :key="typeIndex" class="state-box">
            <h2 :id="typeIndex">{{ typeIndex | uppercase }}</h2>
            <v-row>
                <v-col v-for="(state, stateIndex) in type" :key="stateIndex" class="col-12 col-sm-6 col-md-4" no-gutters>
                    <img v-if="state" :src="require(`../assets/images/ii-toolkit/${state}.jpg`)" width="100%" />
                    <h4 v-if="state">{{ state | removeUnderscores }}</h4>
                </v-col>
            </v-row>
        </div>
    </v-container>

    <!-- <Changelog :changelog="changelog" />  -->
    
  </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'iiToolkit',
    components: {

    },
    data: () => ({
        images: {
            palette: require('../assets/images/IIToolkitPalette.jpg'),
            picker: require('../assets/images/IIToolkitColorPicker.jpg'),
            poster: require('../assets/images/ii-toolkit/ii_toolkit-poster.jpg'),
        },
        video: {
            tutorial: require('../assets/video/ii-toolkit/ii_toolkit-tutorial.mp4'),
            responsive: require('../assets/video/ii-toolkit/ResponsiveText.mp4'),
        },
        projectInfo: {
            name: 'I+I Toolkit',
            subtitle: 'Share valuable research quickly with motion templates',
            source: false,
            about: `It is our goal to elevate the insight from Z Council through the medium of video. 
            
            These videos are generated quickly through the use of a set of flexible Premiere templates –even without design or motion experience.`
        },
        morgts: {
            'data viz': [
                'DataViz_high',
                'DataViz_med',
                'DataViz_low',
            ],
            'speaker': [
                'Speaker_high',
                'Speaker_med',
                'Speaker_low',
                'Speaker_waveform',
                'Speaker_lower_3rd',
            ],
            'text': [
                'Text_center_high',
                'Text_center_med',
                'Text_center_low',
                'Text_center_+_sub',
                'Text_left',
                'Text_left_+_sub',
                'Text_quote_center',
                'Text_quote_left',
                'Text_headline_+_1x1',
                'Text_headline_+_9x16',
                'Text_headline_+_16x9',
            ],
        },
        morgtsImg: {
            'logo': [
                'Logo_full_bleed',
                'Logo_border',
                'Logo_corner_bottom_left',
                'Logo_corner_bottom_right',
                'Logo_corner_top_left',
                'Logo_corner_top_right',
            ],
            'content': [
                '16x9_center',
                '16x9_border',
                '16x9_repeat',
                '16x9_blur',
                '16x9_collage',
                null,
                '9x16_center',
                '9x16_border',
                '9x16_repeat',
                '9x16_blur',
                '9x16_collage',
                null,
                '1x1_center',
                '1x1_border',
                '1x1_repeat',
                '1x1_blur',
                '1x1_collage',
                null,
                '2x3_center',
                '2x3_border',
                '2x3_repeat',
                '2x3_blur',
                '2x3_collage',
                null,
            ],
        },
        changelog: [
            {
                version: '0.2.1',
                date: 'March 15, 2022',
                changed: [
                    'Gestures do not trim the start',
                    'Remove depreciated comp name from expression',
                ],
                fixed: [
                    'Adding keys to a link'
                ],
            },
            {
                version: '0.1.5',
                date: 'Aug 17, 2021',
                changed: [
                    'Consolidate comp and nested comp update buttons',
                    'Cleanup UI with tabs',
                ],
            },
            {
                version: '0.1.4',
                date: 'June 29, 2021',
                changed: [
                    'Removed layer linking in favor of a more clear workflow of not retiming layers'
                ],
                fixed: [
                    'Retain nested marker names'
                ],
            },
            {
                version: '0.1.3',
                date: 'July 21, 2021',
                Added: [
                    'Reaching into a nested comp for marker data',
                    'Update nested comp marker times',
                    'Link layers to markers',
                ],
            },
            {
                version: '0.1.2',
                date: 'June 29, 2021',
                fixed: [
                    'If selected prop has no keys',
                    'Targeted comp when linking keyframes',
                    'The order of shifting keyframes with larger offset values'
                ],
            },
            {
                version: '0.1.1',
                date: 'June 28, 2021',
                added: [
                    'Keyframes and layers may be linked to event markers in other comps',
                ],
                fixed: [
                    'Selecting multiple layers',
                    'Selecting arbitrary number of keyframes',
                    'Better logic for adding and clearing event linking'
                ],
            },
            {
                version: '0.1.0',
                date: 'June 23, 2021',
                comment: ['Initial release'],
            },
        ]
    }),
    filters: {
        uppercase(str) {
            return str.toUpperCase()
        },
        removeUnderscores(str) {
            return str.replace(/_/g, ' ')
        },
    }
}
</script>
<style scoped>

.state-box img {
    border: 1px solid rgba(0,0,0,0.03);
}
.state-box .col {
    margin-bottom: 18px;
}
.state-box h2 {
    /* margin-bottom: -54px; */
}

</style>